import { VeltPresence } from '@veltdev/react';
import { useEffect, useState } from 'react';
import './PresencePage.css';

function PresencePage() {

  const [classString, setClassString] = useState('');

  useEffect(() => {

    const queryParams = new URLSearchParams(window.location.search);
    const _classString = queryParams.get('classString') || false;

    if (_classString) {
      setClassString(_classString);
    }
  }, [classString]);

  return (
    <div id="modifier" className={`presenceContainer ${classString}`}>
      <VeltPresence />
    </div>
  )
}

export default PresencePage;